import Link from 'next/link'
import AppImage from '@/components/AppImage'
import Icon from '@/components/ui/icon'

import { decodeSafeEntities } from '@/lib/sanitise-strings'

export default function SearchResultsHit({ hit }) {
  const postTitle = decodeSafeEntities(hit.post_title)
  const postType = hit?.post_type_label
  const permalink = hit?.permalink
  const businessName = decodeSafeEntities(hit.business_info?.name)
  const location = decodeSafeEntities(hit?.location)

  const postDate = hit?.post_date_formatted
  const eventDate = hit?.event_date?.date_formatted_long

  const imageUrl = hit?.images?.grid_image_url
  const imageAlt = hit?.images?.grid_image_url

  const layoutClass = imageUrl ? 'w-3/4 s:w-full' : 'w-full'

  return (
    <div className="flex gap-x-xl border-b border-gradient py-xl ms:py-m s:py-s s-up:items-center">
      <div className={`${layoutClass}`}>
        {postType ? <p className="mb-xs block text-17 text-grey-800">{postType}</p> : null}

        {postTitle ? (
          <h3 className="h4 mb-xxs">
            <Link href={permalink} className="hover:text-primary">
              {hit.post_title}
            </Link>
          </h3>
        ) : null}

        <ul className="flex ms:flex-col ms-up:items-center [&_li]:text-17 [&_li]:text-grey-800 first:[&_li]:pl-0 last:[&_li]:border-0 ms-up:[&_li]:border-r ms-up:[&_li]:border-grey-800 ms-up:[&_li]:px-xs">
          {postType !== 'Events' && postDate ? <li>{postDate}</li> : null}

          {postType === 'Events' && eventDate ? (
            <li className="flex items-center gap-x-4">
              <Icon id="icon-calendar" width={18} height={18} className="-mt-1" />
              <span>{eventDate}</span>
            </li>
          ) : null}

          {businessName ? <li>{businessName}</li> : null}

          {location ? <li>{location}</li> : null}
        </ul>
      </div>

      <AppImage
        path={imageUrl}
        alt={imageAlt}
        height={237}
        width={396}
        loading="lazy"
        transforms={{
          width: '396',
          height: '237',
          focus: 'auto',
          dpr: 'auto',
          quality: 'auto',
        }}
        className="w-1/4 object-contain s:hidden"
        lqip={{
          active: false,
        }}
        srcSet={{
          396: { width: '396', height: '237' },
          606: { width: '606', height: '363' },
          828: { width: '828', height: '496' },
        }}
      />
    </div>
  )
}
